const DIM_PREFIX = 'dim.'

export function encodeDimFilters(filters: Record<string, string[]>): Record<string, string> {
  const out: Record<string, string> = {}
  for (const [name, values] of Object.entries(filters)) {
    if (values.length === 0) continue
    out[`${DIM_PREFIX}${name}`] = values.join(',')
  }
  return out
}

export function decodeDimFilters(params: Record<string, string>): Record<string, string[]> {
  const out: Record<string, string[]> = {}
  for (const [key, value] of Object.entries(params)) {
    if (!key.startsWith(DIM_PREFIX)) continue
    const name = key.slice(DIM_PREFIX.length)
    out[name] = value.split(',').filter(Boolean)
  }
  return out
}

export function encodeArray(arr: string[]): string {
  return arr.join(',')
}

export function decodeArray(s: string | null): string[] {
  if (!s) return []
  return s.split(',').filter(Boolean)
}
